import { connect } from 'react-redux';

import eventsActionCreators from '_store/_actions/events';

import EventRegistrations from './EventRegistrations';

const mapStateToProps = state => ({
  registrations: state.events.registrations,
  isLoading: state.events.isLoadingRegistrations,
});

const mapDispatchToProps = {
  onFetchRegistrations: eventsActionCreators.fetchEventRegistrations,
  onUpdateRegistration: eventsActionCreators.updateEventRegistration,
  onDeleteRegistration: eventsActionCreators.deleteEventRegistration,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventRegistrations);
